<template>
  <v-dialog v-model="enabledInternal">
    <v-card>
      <v-card-title><v-icon left>mdi-message-draw</v-icon>Translation Helper</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <div class="subtitle-2 mb-5">1) Enter localized messages for each new message key:</div>
            <template v-if="untranslatedMessages && untranslatedMessages.length > 0">
              <v-text-field
                v-for="untranslatedMessage in untranslatedMessages"
                :key="untranslatedMessage"
                :label="untranslatedMessage"
                v-model="untranslatedMessagesFixed[untranslatedMessage]"
              ></v-text-field>
            </template>
            <div v-else class="subtext">No new messages available</div>
          </v-col>
          <v-col>
            <div class="subtitle-2 mb-6">2) Copy & Paste to language file:</div>
            <v-btn @click="copyLangFileNew" color="primary" class="mb-8"><v-icon left>mdi-content-copy</v-icon>Copy new localized JSON to clipboard</v-btn>
            <textarea ref="langFileNewTextArea" style="width: 100%; height: 600px; font-family: monospace; color: #666; background-color: #EAEAEA; padding: 0.5rem;"></textarea>
            <pre ref="langFileNew" style="display: none;">{{ allMessagesGrouped }}</pre>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
import langDe from '../lang/de';
import merge from 'deepmerge';

export default {
  name: 'TranslationHelper',
  props: ['enabled'],
  data: () => ({
    untranslatedMessagesFixed: {},
    enabledInternal : false,
    langFileNewTextContent: null
  }),

  computed: {
    ...mapGetters({
      untranslatedMessages: 'untranslatedMessages'
    }),

    untranslatedMessagesGrouped () {
      let untranslatedMessagesGrouped = {};

      this.untranslatedMessages.forEach(untranslatedMessageKey => {
        let splitParts = untranslatedMessageKey.split('.');
        let lastGroup;
        splitParts.forEach((splitPart, i) => {
          if (!lastGroup) {
            lastGroup = untranslatedMessagesGrouped;
          }
          if (i === splitParts.length - 1) {
            lastGroup[splitPart] = '';
          } else {
            if (typeof lastGroup[splitPart] === 'undefined') {
              lastGroup[splitPart] = {};
            }
          }
          lastGroup = untranslatedMessagesGrouped[splitPart];
        })
      });

      return untranslatedMessagesGrouped;
    },

    allMessagesGrouped () {
      let changedMessagesGrouped = {};
      for (let thekey in langDe) {
        changedMessagesGrouped[thekey] = langDe[thekey];
      }

      const combineMerge = (target, source, options) => {
        const destination = target.slice()

        source.forEach((item, index) => {
          if (typeof destination[index] === 'undefined') {
            destination[index] = options.cloneUnlessOtherwiseSpecified(item, options)
          } else if (options.isMergeableObject(item)) {
            destination[index] = merge(target[index], item, options)
          } else if (target.indexOf(item) === -1) {
            destination.push(item)
          }
        })
        return destination
      }

      let untranslatedMessagesGrouped = {};

      Object.keys(this.untranslatedMessagesFixed).forEach(untranslatedMessageKey => {
        let splitParts = untranslatedMessageKey.split('.');
        let lastGroup;
        splitParts.forEach((splitPart, i) => {
          if (!lastGroup) {
            lastGroup = untranslatedMessagesGrouped;
          }
          if (i === splitParts.length - 1) {
            lastGroup[splitPart] = this.untranslatedMessagesFixed[untranslatedMessageKey];
          } else {
            if (typeof lastGroup[splitPart] === 'undefined') {
              lastGroup[splitPart] = {};
            }
          }
          lastGroup = untranslatedMessagesGrouped[splitPart];
        })
      });

      return merge.all([changedMessagesGrouped, this.untranslatedMessagesGrouped, untranslatedMessagesGrouped], { arrayMerge: combineMerge });
    }
  },

  mounted () {
    this.enabledInternal = false;
    this.$store.dispatch('clearUntranslatedMessages');
  },

  watch: {
    enabled (enabled) {
      this.enabledInternal = enabled;
      this.$nextTick(() => {
        this.fillTextArea();
      });
    },
    enabledInternal (enabledInternal) {
      this.$emit('update:enabled', enabledInternal)
    },

    allMessagesGrouped: {
      deep: true,
      handler () {
        this.$nextTick(() => {
          this.fillTextArea();
        });
      }
    }
  },
  methods: {
    fillTextArea () {
      if (this.$refs.langFileNew) {
        let copyText = this.$refs.langFileNew.textContent;
        this.$refs.langFileNewTextArea.value = 'export default ' + copyText + ';';
      }
    },

    copyLangFileNew () {
      this.$refs.langFileNewTextArea.focus();
      this.$refs.langFileNewTextArea.select();
      document.execCommand("copy");
    }
  }
}
</script>

<style scoped>

</style>
